import { QuizType } from '@vangst/services/oogst/training/useQuiz'
import { SignUpContextEnum } from '@vangst/services/oogst/types'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import { setSessionRedirect } from '@vangst/services/storage'
import { useState } from 'react'
import ClickyBtn from '../../components/navigation/ClickyBtn'
import DialogSignInOrUp from '../viewer/feedback/DialogSignInOrUp'

type PropsType = {
  readonly handleStartQuiz: () => void
  readonly isLoading: boolean
  readonly quiz: QuizType
}
export default function CourseEmptyState(props: PropsType) {
  const [showSignInModal, setShowModal] = useState(false)
  const { authenticating, authenticated } = useViewer()
  if (!authenticating && !authenticated) {
    setSessionRedirect()
  }
  const { handleStartQuiz, isLoading } = props

  const handleClickStart = () => {
    if (!authenticating && !authenticated) {
      setShowModal(true)
      return
    }
    handleStartQuiz()
  }

  return (
    <>
      <ClickyBtn
        className="mood-blue-dark w-full"
        onClick={handleClickStart}
        disabled={isLoading}
      >
        {!authenticating && !authenticated
          ? 'Login To Start Quiz'
          : 'Start Quiz'}
      </ClickyBtn>
      {showSignInModal && (
        <DialogSignInOrUp
          contextMember={SignUpContextEnum.Quiz}
          contextCompany={SignUpContextEnum.Quiz}
          handleClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}
